import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Header, Table, Icon } from 'react-frontier';
import { useBreadcrumbs } from '../Hooks';
import { formatUnix } from '../SiteUtil';
import { EventItem } from '../SiteClasses';
import API from '../API';

var PromoterEvents = ()=>{
	var params = useParams<{ prospect_id?: string, promoter_id?: string }>();
	var { setTitle } = useBreadcrumbs();
	var isProspect = !!params.prospect_id;
	var promoter_id = params.promoter_id ? parseInt(params.promoter_id) : null;

	var [events, setEvents] = useState<EventItem[]>(null);
	var [loadError, setLoadError] = useState<string>(null);

	useEffect(()=>{ setTitle('Eventos'); }, []);
	useEffect(()=>{
		if(!promoter_id) return;
		setLoadError(null);
		API.getEvents(promoter_id).then(res=>{
			if(res.error) return setLoadError(res.message);
			setEvents(res.data || []);
		}).catch(()=>setLoadError('Hubo un error cargando los eventos. (LCL-1)'));
	}, [promoter_id]);

	if(isProspect){
		return <div style={{ paddingTop: 40 }}>
			<Header text='Eventos' subtext='Los eventos se muestran cuando el prospecto se convierte en promotor.' iconName='calendar' />
		</div>;
	}

	if(loadError) return <Header text='Error' subtext={loadError} />;

	return <div style={{ paddingTop: 20 }}>
		<Table fitted striped style={{ maxWidth: 800, margin: '0 auto' }}>
			<Table.Head
				title='Eventos'
				data={[['ID', 'Evento', 'Tipo', 'Lugar', 'Fecha', 'Boletos']]}
				collapsingIndexes={[0, 2, 4, 5]}
			/>
			<Table.Body>
				{!events ? (
					<Table.Row><Table.Cell colSpan={6} centered><Header loading text='Cargando datos' /></Table.Cell></Table.Row>
				) : events.length===0 ? (
					<Table.Row empty><Table.Cell colSpan={6} centered>No hay eventos.</Table.Cell></Table.Row>
				) : events.map(e=>(
					<Table.Row key={e.date_id}>
						<Table.Cell collapsing>{e.date_id}</Table.Cell>
						<Table.Cell>{e.event_name}</Table.Cell>
						<Table.Cell collapsing centered>{e.category_name || <Icon name='minus' />}</Table.Cell>
						<Table.Cell>{e.venue_name || e.city || '-'}</Table.Cell>
						<Table.Cell collapsing>{formatUnix(e.date, 'dd/MMM/yyyy')}</Table.Cell>
						<Table.Cell collapsing centered>{e.tickets_sold}</Table.Cell>
					</Table.Row>
				))}
			</Table.Body>
		</Table>
	</div>;
}

export default PromoterEvents;
